module.exports = __webpack_public_path__ + "static/media/wjmb.e565870a.jpg";